import {COCKPIT_EVENTS_PAGE_TAB_PARAM_KEY} from '@hconnect/common/consts'
import {EventsTab} from '@hconnect/common/types'
import {buildFeatureUrl} from '@hproduce/suite-core'

export const getRcfaListUrl = (plantId: string) => {
  return `${buildFeatureUrl('RcfaList', plantId)}/list?page=0&type=myplant`
}

export const getShiftEventsWorkOrdersUrl = (plantId: string) => {
  return `${buildFeatureUrl('ShiftEvents', plantId)}?${COCKPIT_EVENTS_PAGE_TAB_PARAM_KEY}=${
    EventsTab.WorkOrders
  }`
}
